import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import { Button } from 'app/src/elements/buttons';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions, saleOptions } from './filterOptions';

import { cardStyles as styles } from './index';
import { SEND_SALES_REPORT } from './queries';

const SalesReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();
  const [saleId, setSaleId] = useState();
  const [includeBOS, setIncludeBOS] = useState(false);
  const [useSellerPrice, setUseSellerPrice] = useState(false);

  const [sendSalesReport] = useMutation(SEND_SALES_REPORT);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'sales-report',
      params: {
        'sale-id': saleId,
        'seller-id': sellerId,
        'include-bos': includeBOS,
        'use-seller-price': true,
      },
    });
  };

  const handleEmail = () => {
    if (!saleId) { return; }

    const confirmation = sellerId ?
      'Email Sales Report to seller?' :
      'Email Sales Report to all sellers with assets in this sale?';

    if (confirm(confirmation)) {
      sendSalesReport({
        variables: { sellerId, saleId, includeBOS }
      });
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Sales Report</Text>
      <Text style={styles.label}>Seller (optional):</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <Text style={styles.label}>Sale:</Text>
      <SearchableSelect
        placeholder="Select Sale"
        options={saleOptions(data)}
        value={saleId}
        onChange={setSaleId}
      />
      <View style={{flexDirection: 'row'}}>
        <input
          type="checkbox"
          checked={includeBOS}
          onChange={e => setIncludeBOS(e.target.checked)}
        />
        <Text>Include Bills of Sale (PDF Only)</Text>
      </View>
      <DownloadButton handleDownload={handleDownload}>
        <Button
          label="Email"
          style={
            saleId ? { width: 120 } : { backgroundColor: 'gray', width: 120 }
          }
          onPress={handleEmail}
        />
      </DownloadButton>
    </View>
  );
};

export default SalesReport;
